import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { UserData } from 'apps/idl/src/model';
import { NavigationItems } from 'apps/idl/src/anakin/shared/navigation-items.constants';
import { mergeMap } from 'rxjs/operators';
import { INavigationItem } from '../../../../core/models/navigation/INavigationItem';
import { EModule } from '../../../shared/enums/EModule';
import { FacturationSVService } from '../../../shared/services/facturation-sv.service';
import { HistoriqueService } from '../../../shared/services/historique.service';
import { NavigationService } from '../../../shared/services/navigation.service';
import { PanneauService } from '../../../shared/services/panneau.service';

@Component({
	selector: "di-menu-mobile",
	templateUrl: './menu-mobile.component.html',
	styleUrls: ['./menu-mobile.component.scss'],
})
export class MenuMobileComponent implements OnInit {

	public homeTuiles : INavigationItem[] = NavigationItems;

	constructor(private router: Router,
		private svcNavigation: NavigationService,
		private cdr: ChangeDetectorRef,
		private svcHistorique: HistoriqueService,
		private svcFacturationSV: FacturationSVService,
		private svcPanneau: PanneauService
	) { }

	mobileTuiles : INavigationItem[];

	ngOnInit() {

		this.mobileTuiles = this.homeTuiles.filter(item => {
			if (!item.moduleOptionnel) return true;
			return UserData.modules.includes(EModule.dpcv);
		});

		this.mobileTuiles.forEach((navigationItem: INavigationItem) => {
			if (navigationItem.openOverlay) {
				navigationItem.onClick = () => this.svcPanneau.open(navigationItem.label, navigationItem.openOverlay, {});
			} else {
				navigationItem.onClick = () => this.redirect(navigationItem.route)
			}
		});

		this.svcNavigation.navigationItems$.subscribe(items => {
			this.homeTuiles = items;
			this.cdr.detectChanges();
		});

		this.svcHistorique.getBadgeTransmissionFromHistorique().pipe(
			mergeMap(() => this.svcFacturationSV.updateFacturesPrepareesBadgeCount()),
		).subscribe();
	}

	public redirect(route: string[]): void {
		if (!route.includes("#"))
			this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
				this.router.navigate(route)
			});
	}
}
